<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid"
                >
                <div class="row">
                    <div class="col-12 mb-4">

                        <v-card>
                            <v-tabs
                                    v-model="tab"
                                    background-color="transparent"
                                    color="basil"
                                    grow
                            >
                                <v-tab
                                        v-for="item in items"
                                        :key="item"
                                >
                                    {{ item }}
                                </v-tab>
                            </v-tabs>

                            <v-tabs-items v-model="tab">
                                <v-tab-item
                                        key="Commandes en cours"
                                >
                                    <v-card
                                            color="basil"
                                            flat
                                    >

                                        <Commandecourspharma />
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item
                                        key="Commandes effectuées"
                                >
                                    <v-card
                                            color="basil"
                                            flat
                                    >
                                        <Commandeeffectuepharma />
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item
                                        key="Commandes manuelles"
                                >
                                    <v-card
                                            color="basil"
                                            flat
                                    >

                                        <Commandemanuelpharma />
                                    </v-card>
                                </v-tab-item>

                            </v-tabs-items>

                            <div style="padding: 1%; text-align: center">
                                 <v-btn @click="initialize()" color="primary" fab small dark>
                                  <v-icon>mdi-refresh-circle</v-icon>
                                </v-btn>

                            </div>

                        </v-card>


                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>
            </div>


        </div>

    </div>
</template>

<script>
    import Commandecourspharma from "./Commandecourspharma";
    import Commandeeffectuepharma from "./Commandeeffectuepharma";
    import Commandemanuelpharma from "./Commandemanuelpharma";
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";

    export default {
        name: "Commande",

        components: {Commandecourspharma,Commandeeffectuepharma,Commandemanuelpharma},
        data() {
            return {
                tab: null,
                items: [
                    'Commandes en cours', 'Commandes effectuées','Commandes manuelles',
                ],

                submitting: false,
                valid: true,
                lazy: false,
                errors: undefined,
                search: '',
                dialog: '',
                id: undefined,
                snackbar: false,
                textSnack: '',
                user: JSON.parse(localStorage.getItem("user")),
                roles:JSON.parse(localStorage.getItem("mineroles")),
                GC:false,
                headers: [
                    {
                        text: 'Code',
                        align: 'start',
                        sortable: true,
                        value: 'code',
                    },
                    {text: 'Libellé', value: 'libel'},
                    {text: 'Actions', value: 'actions', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                libelRules: [
                    v => !!v || 'Libellé requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codeRules: [
                    v => !!v || 'Code requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle catégorie" : "Mise à jour"
            }
            ,
             ...mapState('precommandes/', ['precommandesEff','precommandesEffloading']),
             ...mapState('precommandes/', ['precommandesManuel']),
             ...mapState('precommandes/', ['precommandesEncours','precommandesEncoursloading'])


        }
        ,
        mounted() {
            window.scrollTo(0,0);

            
            if (this.user.type_compte == "pharmacie")
            {
                if (!this.roles.includes("GC")){
                    this.$router.push("permission");
                }
            }
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {



                    let data = new FormData();
                    data.append("state_client_get", "false");
                    data.append("pharmacie", this.user.relation._id);
                    data.append("pharma_get", "true");
                    this.$store.dispatch('precommandes/getPrecommandeEff', data).then(response => {
                        window.console.log('precommandes', response)
                    });

                     data = new FormData();
                    data.append("state_client_get", "false");
                    data.append("pharma_get", "false");
                    data.append("pharmacie", this.user.relation._id);
                    this.$store.dispatch('precommandes/getPrecommandesManuel', data).then(response => {
                        window.console.log('precommandes', response)
                    });


                     data = new FormData();
                    data.append("state_client_get", "false");
                    data.append("pharma_get", "false");
                    data.append("pharmacie", this.user.relation._id);
                    this.$store.dispatch('precommandes/getPrecommandeCours', data).then(response => {
                        window.console.log('precommandes', response)
                    });


            }
            ,

            editItem(item) {
                this.editedIndex = this.categories.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('categories/deleteCategorie', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("code", this.editedItem.code);
                data.append("libel", this.editedItem.libel);
                let mineroute = 'categories/setCategorie';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id);
                    mineroute = 'categories/setUpdateCategorie';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor() {
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>